const configuration = {
  url: process.env.NODE_ENV === 'development'?"http://localhost:8082":"https://www.ifandy.xyz/api",
  appId: "1905618898",
  redirectUri: "https://www.ifandy.xyz/api/oauth/qq/callback",
}

export default configuration



// WEBPACK FOOTER //
// ./src/common/config.js